"use client";
import { GET_PRODUCT_APPLICATION, PRODUCT_HANDLER } from "@/lib/constants";
import ENV from "@/lib/constants/EnvVariables";
import { useFooter } from "@/lib/context/FooterContext";
import useErrorHandling from "@/lib/hooks/errorhandling";
import useLogoutHook from "@/lib/hooks/logoutHook";
import useStageErrorHandler from "@/lib/hooks/stageErrorHandler";
import {
  useBankMandateMutation,
  useBankMandateStatusMutation,
  useBankPennyDropMutation,
  useGetApplicationQuery,
  useGetApplicationStageConfigQuery,
  useGetCustomerQuery,
  useLazyJuspayOrderStatusQuery,
  useLazyTriggerUcicQuery,
} from "@/lib/redux";
import { setModalAttributes } from "@/lib/redux/slice/ModalSlice";

import { useFormik } from "formik";
import { useTranslations } from "next-intl";
import { enqueueSnackbar } from "notistack";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import ErrorModal from "../repayment-mode/error-modal";
import IfscDrawer from "./repayment-banking/ifsc-drawer";
import ROUTES from "@/lib/constants/PageRoutes";
import { checkForRpl } from "@/lib/utils/rpl.utils";
import { sendEventAnalytics } from "@/lib/hooks/eventAnalytics";
import { usePolling } from "@/lib/hooks/common.hooks";
import PennyDropPollingModal from "./PennyDropPollingModal";
import { sessionStorageUtil } from "@/lib/utils/common.utils";
import { useSearchParams } from "next/navigation";
import BankDetailsAA from "./repayment-banking-aa";
import BankDetails from "./repayment-banking";

const RepaymentBanking = ({ product }) => {
  /***************************************RTK************************************ */
  //get customer details
  const { data: customerData, isLoading: fetchingCustomerData } =
    useGetCustomerQuery();
  // fetch application data from get api
  const {
    data: applicationData,
    error: errorGetApplication,
    isLoading: applicationLoading,
    refetch: refetchApplicationData,
    isSuccess: isSuccessApplication,
  } = useGetApplicationQuery("", {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
  });

  const productApplication = GET_PRODUCT_APPLICATION(
    PRODUCT_HANDLER[product],
    applicationData?.data,
  );

  const isAAorPerfiosFlow = ["AA", "PERFIOS"]?.includes(
    productApplication?.bankVerificationMode,
  );

  return isAAorPerfiosFlow ? (
    <BankDetailsAA product={product} />
  ) : (
    <BankDetails product={product} />
  );
};
export default RepaymentBanking;
